<template>
  <div
    class="modal-fade"
    @click.self="emitClose"
  >
    <slot />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'ModalFade',
    props: {
      closeClickOutside: {
        type: Boolean as PropType<boolean>,
        default: true,
      },
    },

    methods: {
      emitClose() {
        this.$emit('close');
      },
    },
  });
</script>

<style lang="scss" scoped>
  .fade {
    &-enter-active,
    &-leave-active {
      opacity: 0;
    }
  }
  .modal-fade {
    transition: opacity 0.3s ease-in;
    // background: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
  }
</style>
